/**
 * Which data panel views are out in windows of their own, for the tab strip.
 *
 * A context rather than props because the strip is rendered by four hosts — the
 * docked dialog, the screener's slot, the panel's own window and the hover peek
 * — and each would otherwise thread three more props to it. `App` owns the list
 * (view state, D8, like the panel's own `detached`) and the windows; the strip
 * only asks.
 *
 * `null` where views do not detach: a phone, an installed PWA (`canDetach`),
 * and anything rendered outside `App`.
 */

import { createContext, useContext } from "react";

import type { SymbolView } from "./symbol-views";

export interface ViewDetach {
  /** Views in their own windows. Their tabs stay, marked ⧉. */
  detached: readonly SymbolView["id"][];
  /** Open a view in its own window. Called from a click, which a popup needs. */
  detach: (view: SymbolView["id"]) => void;
  /** Bring a detached view's window forward — what clicking its tab means. */
  focus: (view: SymbolView["id"]) => void;
}

export const ViewDetachContext = createContext<ViewDetach | null>(null);

export function useViewDetach(): ViewDetach | null {
  return useContext(ViewDetachContext);
}
